// `React` must be in SCOPE, not merely resolvable: the kiosk renderchecks run ts-node with
// `"jsx": "react"` (the classic runtime), which compiles this file's JSX to
// `React.createElement`. The app bundlers use the automatic runtime and need no import, so a
// missing one here builds clean and throws only in those node-only gates.
import React from "react";
import Svg, { Path } from "react-native-svg";

/**
 * The star drawn where the synthetic "Recommended" category would show a picture.
 *
 * That row has no `imageDataId` — it is not a merchant category — so the rail's tile would
 * otherwise be a blank tinted box. Drawn rather than fetched: a kiosk has to render its own
 * chrome with no internet (KIOSK_ARCHITECTURE §8), and `KioskImage`'s header is explicit that
 * an `.svg` URL cannot be decoded by RN's `<Image>` on Android or iOS.
 */
export function RecommendedIcon({
  color,
  width,
  height,
}: {
  color: string;
  width?: number;
  height?: number;
}) {
  return (
    <Svg width={width ?? 24} height={height ?? 24} viewBox="0 0 24 24" fill="none">
      <Path
        fill={color}
        d="M12 2.25c.33 0 .631.19.773.489l2.548 5.35 5.72.855a.859.859 0 0 1 .474 1.45l-4.15 4.176.98 5.92a.859.859 0 0 1-1.256.896L12 18.58l-5.089 2.806a.859.859 0 0 1-1.256-.896l.98-5.92-4.15-4.175a.859.859 0 0 1 .474-1.451l5.72-.855 2.548-5.35A.859.859 0 0 1 12 2.25Z"
      />
    </Svg>
  );
}
RecommendedIcon.displayName = "RecommendedIcon";
export default RecommendedIcon;
